import { render, staticRenderFns } from "./checkoutV8.vue?vue&type=template&id=ddcd282e&scoped=true"
import script from "./checkoutV8.vue?vue&type=script&lang=js"
export * from "./checkoutV8.vue?vue&type=script&lang=js"
import style0 from "./checkoutV8.vue?vue&type=style&index=0&id=ddcd282e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcd282e",
  null
  
)

export default component.exports